import React from 'react'

import Menu from 'layout/components/menu/menu'
import UpdateReminder from '@/modules/base/components/updateReminder'

const MenuWrapper = ({ showAccountOnly = false }) => {
  return (
    <>
      <Menu showAccountOnly={showAccountOnly} />
      <UpdateReminder />
    </>
  )
}

export default MenuWrapper
